import React from 'react';
import TextInput from '../Inputs/TextInput';
import { Translate } from '@above-the-treeline/localization';

export default function PostalCodeAndPhoneInputRow() {
	return (
		<div className="info-option">
			<div className="info-option-label">
				<Translate id="postal" />
			</div>
			<div className="postal-input-and-phone-input-group">
				<div className="postal-input-container">
					<TextInput inputId="zip" />
				</div>
				<span className="phone-label">
					<Translate id="phone" />
				</span>
				<TextInput inputId="phone" />
			</div>
		</div>
	);
}
